export const ROLE_SET = 'SET_ROLE'

export const ROLE_BUYER = 'BUYER'
export const ROLE_BUYER_ADMIN = 'BUYER_ADMIN'

export const ROLE_SUPPLIER = 'SUPPLIER'

export const ROLE_ADMIN = 'ADMIN'
